import { UsersService } from "@/services/users/users.service";
import { AuthService } from "@/services/auth/auth.service";
const _usersService = new UsersService();
const _authService = new AuthService();

const setUserAction = ({ commit }, payload ): void => {
  commit("setUser", payload);
};

const setSpaceUserLocal = ({ commit }, payload): void => {
  commit("setSpaceUser", payload);
};

const setConfiguration = ({ commit }, { userId, props, callback }): void => {
  _usersService
    .updateConfiguration(props, userId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const setGameKillerAction = ({ commit }, payload: boolean): void => {
  commit("setGameKiller", payload);
};

const getUserAction = ({ commit, dispatch }, { callback }): void => {
  _usersService
    .getUserLoged()
    .then((response) => {
      commit("setUser", response.data);
      localStorage.setItem("email", response.data.email);
      localStorage.setItem(
        "camera_options",
        response.data.isNavigationActivated
      );
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};
const getUserByIdAction = ({ commit }, { userId, callback }): void => {
  _usersService
    .getUserById(userId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getUserInfoSuperSpaceAction = (
  { commit },
  { superSpaceUserId, callback }
): void => {
  _usersService
    .getUserInfoSuperSpace(superSpaceUserId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getSpaceUserAction = ({ commit }, { spaceId, callback }): void => {
  _usersService
    .getSpaceUserLoged(spaceId)
    .then((response) => {
      localStorage.setItem("email", response.data.superSpaceUser.user.email);
      commit("setGameKiller", response.data.isAssassinInAssassinGame);
      commit("setSpaceUser", response.data);
      localStorage.setItem(
        "camera_options",
        response.data.superSpaceUser.user.isNavigationActivated
      );
      localStorage.setItem(
        "space_label",
        response.data.superSpaceUser.user.isRoomLabelActivated
      );

      localStorage.setItem(
        "voice_enabled",
        response.data.superSpaceUser.user.isNoiseCancellationActivated
      );

      const blur = response.data.superSpaceUser.user.cameraBlur;
      switch (blur) {
        case "OFF":
          localStorage.setItem("blur_amount", "0");
          localStorage.setItem("blur_enabled", "false");
          break;
        case "LOW":
          localStorage.setItem("blur_amount", "2");
          localStorage.setItem("blur_enabled", "true");
          break;
        case "MEDIUM":
          localStorage.setItem("blur_amount", "7");
          localStorage.setItem("blur_enabled", "true");
          break;
        case "HIGH":
          localStorage.setItem("blur_amount", "15");
          localStorage.setItem("blur_enabled", "true");
          break;
      }

      const config = {
        call: {
          noMic:
            response.data.superSpaceUser.user.closeMicrophoneWhenJoinMeeting,
          noCam: response.data.superSpaceUser.user.closeCameraWhenJoinMeeting,
          sound: response.data.superSpaceUser.user.soundLevel,
        },
        notification: {
          silenceNotification:
            response.data.superSpaceUser.user.isNotificationDisabled,
        },
        sound: {
          silenceReactions:
            response.data.superSpaceUser.user.isReactionSoundDisabled,
        },
        chat: {
          openRoomChatByDefault:
            response.data.superSpaceUser.user.openRoomChatByDefault,
          sendMeetingChatConversationToEmail:
            response.data.superSpaceUser.user.sendMeetingChatConversationToEmail
        },
      };
      commit("setConfig", config);
      localStorage.setItem(
        "default_emoji",
        response.data.superSpaceUser.user.emoji
      );
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const updateUserAction = (
  { commit, state },
  { userId, props, callback, callbackError }
): void => {
  _usersService
    .updateUser(props, userId)
    .then((response) => {
      if (state.spaceUser && state.spaceUser.user)
        state.spaceUser.user = response.data;
      if (state.spaceUser && state.spaceUser.superSpaceUser)
        state.spaceUser.superSpaceUser.user = response.data;
      commit("setUser", response.data);
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updateUserWorkInOfficeAction = (
  { commit, state },
  { userId, props, callback, callbackError }
): void => {
  _usersService
    .updateUserWorkInOffice(props, userId)
    .then((response) => {
      state.spaceUser.user = response.data;
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updateUserStatusAction = (
  { commit, state },
  { userId, props, callback }
): void => {
  _usersService
    .updateStatusUser(props, userId)
    .then((response) => {
      state.spaceUser.user = response.data;
      if (
        response.data.emoji != undefined &&
        response.data.emoji != "U+1F4DE"
      ) {
        const pre_status = {
          availableStatus: response.data.availableStatus,
          availableStatusReason: response.data.availableStatusReason,
          emoji: response.data.emoji,
        };
        localStorage.setItem("pre_status", JSON.stringify(pre_status));
      }
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const updateUserAvatarAction = (
  { commit },
  { userId, props, callback, callbackError }
): void => {
  _usersService
    .updateUserAvatar(userId, props)
    .then((response) => {
      commit("setUser", response.data);
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updateUserPetAction = (
  { commit },
  { userId, props, callback, callbackError }
): void => {
  _usersService
    .updateUserPet(userId, props)
    .then((response) => {
      commit("setUser", response.data);
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const uploadUserProfileImageAction = (
  { commit },
  { data, callback, callbackError }
): void => {
  _usersService
    .uploadUserProfileImage(data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const saveSpaceUserPositionAction = (
  { commit },
  { userId, props, callback, callbackError }
): void => {
  _usersService
    .updateSpaceUserPosition(userId, props)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const saveSpaceUserDefaultPositiontAction = (
  { commit },
  { userId, callback, callbackError }
): void => {
  _usersService
    .updateSpaceUserDefaultPosition(userId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const loadPreviousStatusAction = async (
  { commit, rootGetters },
  { store, callback = null, callbackError = null }
): Promise<void> => {
  const localSpaceUser = rootGetters["UserStore/getSpaceUser"];
  //const previousStatus = rootGetters["UserStore/getPreviousStatus"];
  let room = rootGetters["SystemStore/getCurrentRoom"];
  if (room && room.id) {
    await store.dispatch("GraphicClientStore/inTheSpace", room.id);
    if (localStorage.getItem("inTheRoom") == "true") {
      return;
    }
  }
  const previousStatus = JSON.parse(localStorage.getItem("pre_status"));
  let id = null;
  if (localSpaceUser != undefined && localSpaceUser.user != undefined)
    id = localSpaceUser.superSpaceUser.user.id;
  else id = localStorage.getItem("user");
  if (id == null) return;
  _usersService
    .updateStatusUser(
      {
        availableStatus: previousStatus.availableStatus,
        availableStatusReason: previousStatus.availableStatusReason,
        emoji: localStorage.getItem("default_emoji"),
      },
      id
    )
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      if (callbackError) callbackError(error);
    });
};

const requestSpaceUserTechnicalInfoAction = (
  { commit },
  { userId, spaceId, callback, callbackError }
): void => {
  _usersService
    .requestSpaceUserTechnicalInfo(userId, spaceId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const sendSpaceUserTechnicalInfoAction = (
  { commit },
  { requestedFromSpaceUser, technicalInfo, callback, callbackError }
): void => {
  _usersService
    .sendSpaceUserTechnicalInfo(requestedFromSpaceUser, technicalInfo)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const activateUserAction = (
  { commit },
  { token, space, callback, callbackError }
): void => {
  _usersService
    .activateUser(token)
    .then((response) => {
      if (response.data.token) {
        localStorage.clear();
        localStorage.setItem("space_default", space);
        _authService.decodeJwt(response.data);
      }
      callback(response);
    })
    .catch((error) => {
      callbackError();
    });
};

const activateGuestAction = (
  { commit },
  { token, data, callback, callbackError }
): void => {
  _usersService
    .activateGuest(token, data)
    .then((response) => {
      if (response.data.token) {
        _authService.decodeJwt(response.data);
        localStorage.setItem("guestInvitationToken", response.data.token);
        localStorage.setItem(
          "guestInvitationRefreshToken",
          response.data.refresh_token
        );
        callback();
        location.reload();
      } else {
        callbackError(response);
      }
    })
    .catch((error) => {
      callbackError(error);
    });
};

const sendInvitationsAction = (
  { commit },
  { data, callback, callbackError }
) => {
  _usersService
    .sendInvitation(data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const deleteUserAction = (
  { commit },
  { password, userId, callback, callbackError }
) => {
  _usersService
    .deleteUser(password, userId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const setPositionAction = ({ commit }, props): void => {
  commit("setPosition", props);
};

const connectToSpaceAction = (
  { commit },
  { props, id, callback, callbackError }
): void => {
  _usersService
    .connectToSpace(props, id)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const setConfigAction = ({ commit }, props): void => {
  commit("setConfig", props);
};

const setConfigSilenceNotificationAction = ({ commit }, props): void => {
  commit("setConfigSilenceNotification", props);
};

const removeImageUserAction = ({ commit }, { imageId, callback, callbackError }) => {
  _usersService
    .removeImageUser(imageId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getChatsBotAction = ({ commit }, { spaceId, page, callback, callbackError }) => {
  _usersService
    .getChatsBot(spaceId, page)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getHistoryBotAction = ({ commit }, { spaceId, idChat, page, callback, callbackError }) => {
  _usersService
    .getHistoryBot(spaceId, idChat, page)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const sendMessageBotAction = ({ commit }, { spaceId, idChat, data, callback, callbackError }) => {
  _usersService
    .sendMessageBot(spaceId, idChat, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createTitleChatBotAction = ({ commit }, { spaceId, idChat, callback, callbackError }) => {
  _usersService
    .createTitleChatBot(spaceId, idChat)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createChatBotAction = ({ commit }, { spaceId, callback, callbackError }) => {
  _usersService
    .createChatBot(spaceId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createTitleChatAction = ({ commit }, { spaceId, idChat, callback, callbackError }) => {
  _usersService
    .createTitleChatBot(spaceId, idChat)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};


const setCurriculumAction = ({ commit }, { data, callback, callbackError }): void => {
  _usersService
    .createCurriculum(data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const deleteCurriculumAction = ({ commit }, { id, callback, callbackError }): void => {
  _usersService
    .deleteCurriculum(id)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updateCurriculumAction = ({ commit }, { id, data, callback, callbackError }): void => {
  _usersService
    .updateCurriculum(id, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getAssistantsAction = ({ commit }, { superSpaceId, callback, callbackError }) => {
  _usersService
    .getAssistants(superSpaceId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getAssistantChatsAction = ({ commit }, { superSpaceId, assistantId,  callback, callbackError }) => {
  _usersService
    .getAssistantChats(superSpaceId, assistantId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getAssistantChatHistoryAction = ({ commit }, { idChat, superSpaceId, idMessage, callback, callbackError }) => {
  _usersService
    .getAssistantChatHistory(idChat, superSpaceId, idMessage)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createAssistantChatAction = ({ commit }, { superSpaceId, data, callback, callbackError }) => {
  _usersService
    .createAssistantChat(superSpaceId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const sendAssistantMessageAction = ({ commit }, { idChat, superSpaceId, data, callback, callbackError }) => {
  _usersService
    .sendAssistantMessage(idChat, superSpaceId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createAssistantTitleAction = ({ commit }, { idChat, superSpaceId, callback, callbackError }) => {
  _usersService
    .createAssistantTitle(idChat, superSpaceId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const sendServerPingAction = ({ commit }, { spaceUserId, callback, callbackError }) => {
  _usersService
    .sendServerPing(spaceUserId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const setIsOnlineAction = ({ commit }, payload): void => {
  commit("setIsOnline", payload);
};

export default {
  getUserAction,
  updateUserAction,
  updateUserStatusAction,
  getSpaceUserAction,
  updateUserAvatarAction,
  uploadUserProfileImageAction,
  setUserAction,
  updateUserWorkInOfficeAction,
  setSpaceUserLocal,
  getUserByIdAction,
  saveSpaceUserPositionAction,
  loadPreviousStatusAction,
  requestSpaceUserTechnicalInfoAction,
  sendSpaceUserTechnicalInfoAction,
  activateUserAction,
  sendInvitationsAction,
  activateGuestAction,
  setConfiguration,
  saveSpaceUserDefaultPositiontAction,
  updateUserPetAction,
  deleteUserAction,
  setPositionAction,
  connectToSpaceAction,
  getUserInfoSuperSpaceAction,
  setConfigAction,
  setConfigSilenceNotificationAction,
  removeImageUserAction,
  getChatsBotAction,
  getHistoryBotAction,
  sendMessageBotAction,
  createTitleChatBotAction,
  createChatBotAction,
  createTitleChatAction,
  setGameKillerAction,
  setCurriculumAction,
  deleteCurriculumAction,
  updateCurriculumAction,
  getAssistantsAction,
  getAssistantChatsAction,
  createAssistantChatAction,
  sendAssistantMessageAction,
  createAssistantTitleAction,
  getAssistantChatHistoryAction,
  sendServerPingAction,
  setIsOnlineAction,
};

